/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'ORDINARY_OVERTIME_HOURS',
              'OVERTIME_HOURS_PERFORMED_AT_NIGHT',
              'OVERTIME_HOURS_PERFORMED_ON_WEEKLY_REST_DAYS',
              'OVERTIME_HOURS_PERFORMED_ON_PUBLIC_HOLIDAYS',
              'IS_THE_FACILITY_FAILING_TO_PAY_WORKERS_CORRECTLY_FOR_ANY_OF_THE',
              'ARE_PIECE_RATE_WORKERS_PAID_CORRECTLY_FOR_ORDINARY_HOURS_OF_WOR',
              'ARE_OVERTIME_ALLOWANCES_PROVIDED_PAID_IN_LINE_WITH_LEGAL_REQUIR',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    which_of_the_following_types_of_overtime_hours_is_the_fac_faili: valueSchema,
  },
}
